export default __webpack_public_path__ + "static/media/did-you-see-that.7646fb34.gif";